import { defineLanguage } from '../../../src/domain/language/factory';

export default defineLanguage({
  languageName: 'English',
  languageCode: 'en',
  languageHeaderCode: 'en',
});
